import { CSSProperties } from 'react';
import { Typography } from '@tempmee/react';
import { Row } from '~/commonComponents';

interface ILabelValueDisplayProps {
  label: string;
  value?: string | null;
  labelStyle?: CSSProperties;
  valueStyle?: CSSProperties;
  containerStyle?: CSSProperties;
}

export const LabelValueDisplay = ({
  label,
  value = '',
  labelStyle,
  valueStyle,
  containerStyle,
}: ILabelValueDisplayProps) => {
  return (
    <Row flex={1} alignItems="flex-start" gap={15} style={containerStyle}>
      <Typography
        as="span"
        size="body_large"
        bold
        style={{
          wordBreak: 'break-word',
          flex: 0.4,
          ...labelStyle,
        }}
      >
        {label}
      </Typography>
      <Typography as="span" style={{ flex: 1, wordBreak: 'break-word', ...valueStyle }}>
        {value}
      </Typography>
    </Row>
  );
};
